export default __webpack_public_path__ + "static/media/plan50.a097979b.svg";